import React from 'react';
import {
  AlertTriangle,
  Eye,
  MessageSquare,
  Repeat,
  Volume2,
  Users,
  Focus,
  Brain,
  Frown,
  AlertCircle
} from 'lucide-react';
import SignalCard from './SignalCard';

const RiskSignals = () => {
  const signals = [
    {
      icon: <Eye className="w-6 h-6 text-amber-500" />,
      text: 'Evita mirar a los ojos o no responde cuando se le llama por su nombre.'
    },
    {
      icon: <MessageSquare className="w-6 h-6 text-amber-500" />,
      text: 'Habla muy poco o ha dejado de hablar después de haber aprendido.'
    },
    {
      icon: <AlertCircle className="w-6 h-6 text-amber-500" />,
      text: 'No muestra cosas que le interesan (no te lleva un juguete para enseñártelo o no te lo señala con el dedo).'
    },
    {
      icon: <Repeat className="w-6 h-6 text-amber-500" />,
      text: 'Repite movimientos constantemente como agitar las manos, girar sobre sí mismo o alinear objetos.'
    },
    {
      icon: <Volume2 className="w-6 h-6 text-amber-500" />,
      text: 'Reacciona con molestia extrema ante sonidos, texturas o cambios en su rutina diaria.'
    },
    {
      icon: <Users className="w-6 h-6 text-amber-500" />,
      text: 'No juega con otros niños, prefiere estar solo o no sabe cómo unirse al juego.'
    },
    {
      icon: <Focus className="w-6 h-6 text-amber-500" />,
      text: 'Se enfoca intensamente en un solo objeto o tema, como ver girar una rueda o hablar solo de trenes.'
    },
    {
      icon: <Brain className="w-6 h-6 text-amber-500" />,
      text: 'Le cuesta mostrar lo que siente o entender cómo se sienten los demás.'
    },
    {
      icon: <Frown className="w-6 h-6 text-amber-500" />,
      text: 'Se enoja fácilmente cuando no logra hacerse entender.'
    }
  ];

  return (
    <section id="signals" className="py-16 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <div className="inline-flex items-center justify-center mb-4">
            <AlertTriangle className="w-8 h-8 text-amber-500" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-800 mb-4">Señales de Riesgo a Observar</h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Estas conductas pueden ser señales tempranas de alerta. No significan que un niño tenga autismo, 
            pero sí que debería ser evaluado por un especialista:
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {signals.map((signal, index) => (
            <SignalCard 
              key={index}
              icon={signal.icon}
              text={signal.text}
              delay={index * 100}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default RiskSignals;
